export const buildSaleListRequest = (query = {}, requiredParams = {}) => {
  const rawParams = query.params ? { ...query.params } : { ...query };

  if (rawParams.cursor != null && rawParams.cursor !== '') {
    // Admin Sales V2 cursors are opaque and inherit the original filters and
    // page size. The backend contract requires cursor requests to send only
    // the cursor value.
    return {
      config: { params: { cursor: rawParams.cursor } },
      append: true
    };
  }

  const initialParams = { ...rawParams };
  delete initialParams.page;
  delete initialParams.cursor;
  return {
    config: { params: { ...initialParams, ...requiredParams } },
    append: false
  };
};

export const mergeSaleListResponse = (payload = {}, currentList = {}, append = false) => {
  const nextData = Array.isArray(payload.data) ? payload.data : [];
  const currentData = Array.isArray(currentList.data) ? currentList.data : [];

  return {
    ...payload,
    data: append ? [...currentData, ...nextData] : nextData,
    has_more: Boolean(payload.has_more),
    next_cursor: payload.next_cursor == null ? null : payload.next_cursor
  };
};

export const getMarketplaceShippingMethod = (sale = {}) => (
  sale.tiktok_shipping_method || sale.shopee_shipping_method || null
);
